import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CalendarExtend from './calendar-extend';
import CalendarMini from './calendar-mini';

class ParagraphCalendar extends Component {
  render() {
    if (!!this.props.content.fieldMinikalender) {
      return (
        <section className="paragraph paragraph-calendar">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <CalendarMini />
              </div>
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="paragraph paragraph-calendar">
        <CalendarExtend />
      </section>
    );
  }
}

ParagraphCalendar.propTypes = {};

export default ParagraphCalendar;
